import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P } from '@slal/ui/typography';
import { MaxWidthContent, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { useKeyConsiderationsApplicationForm } from './hooks';
import { SelectedYesNoContent } from './SelectedYesNoContent';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>Great</Heading>
            <P>
                Being invested is an important part of accessing your money flexibly. It means you can benefit from
                investment growth, but also means your pension value could drop if markets fall and you could get back
                less than you paid in.
            </P>
            <P markdown>
                You can reconsider your choice at any time. Read the
                [MoneyHelper](https://library.standardlife.co.uk/mas_guide.pdf) guide for information on your options,
                and seek guidance from [Pension
                Wise](https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise?source=pw), a service from
                MoneyHelper or advice from a financial adviser.
            </P>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>That's OK, but it's an important part of having flexible access to your money</Heading>
            <P>
                Being invested means that you can benefit from investment growth, but also means your pension value
                could drop if markets fall and you could get back less than you paid in. You need to be comfortable with
                this. If you are looking for a stable income that is guaranteed, you could consider setting up a
                guaranteed income (an annuity) which is designed to provide this.
            </P>
            <P markdown>
                You can reconsider your choice at any time. Read the
                [MoneyHelper](https://library.standardlife.co.uk/mas_guide.pdf) guide for information on your options,
                and seek guidance from [Pension
                Wise](https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise?source=pw), a service from
                MoneyHelper or advice from a financial adviser.
            </P>
        </Article>
    );
};

export const StillInvestedForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'stillInvested',
        '/application/key-considerations/remaining-pension'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Still invested">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/continue-contributing" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
